import script from "./NewClient.vue?vue&type=script&setup=true&lang=js"
export * from "./NewClient.vue?vue&type=script&setup=true&lang=js"

import "./NewClient.vue?vue&type=style&index=0&id=43c49e83&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43c49e83"]])

export default __exports__